DJ.addBehavior('return-btn', '.return-btn', {
  attach: function(context, settings, behavior) {
    jQuery(this).on('click', function(e) {
      e.preventDefault();
      history.back(1);
    });
  },

  detach: function(context, settings) {}
});
